// 配置设置

// 是否开启代理
const base_url = process.env.VUE_APP_PROXY == 'YES' ? '/localServe' : process.env.VUE_APP_BASE_API

module.exports = {
  BASE_API: base_url
}
